/*
  ============================================================
  carrinho.js — carrinho lateral (drawer) + add-to-cart via AJAX
  ============================================================

  O QUE FAZ:
  1. Intercepta o envio de qualquer formulario de add-to-cart e
     envia para a Cart AJAX API do Shopify (/cart/add.js). Em caso
     de sucesso, busca o carrinho atualizado (/cart.js), redesenha
     a lista de itens do carrinho lateral e ABRE o drawer (isso
     substitui o antigo toast "Added to cart" como confirmacao).
  2. Controla abrir/fechar do carrinho lateral (snippets/carrinho.liquid):
     - Abre ao clicar em qualquer [data-cart-drawer-open] (icone do
       carrinho no header).
     - Fecha ao clicar no overlay, no X, em "continuar comprando"
       ([data-cart-drawer-close]) ou ao apertar Esc.
  3. Dentro do drawer, os botoes +/- e remover chamam
     /cart/change.js (por cart item key) e redesenham a lista com
     os dados retornados — sem recarregar a pagina.

  OBSERVACOES:
  - Funciona sem JS: os formularios de produto enviam nativamente
    para /cart/add, e o icone do carrinho e um link normal para
    /cart. Se o fetch falhar de verdade (erro de rede), o form de
    add-to-cart cai para o submit tradicional.
  - O contador do header usa elementos com [data-cart-count].
  - window.themeMoneyFormat e window.themeStrings sao definidos em
    snippets/carrinho.liquid (formato de moeda da loja e strings
    traduzidas usadas aqui).
*/
(function () {
  'use strict';

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // ------------------------------------------------------------
  // Formatacao de moeda (mesma logica do filtro `money` do Shopify)
  // ------------------------------------------------------------
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var plain = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/, plain);
  }

  // ------------------------------------------------------------
  // Contador do carrinho no header
  // ------------------------------------------------------------
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  function fetchCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  // ------------------------------------------------------------
  // Carrinho lateral (drawer)
  // ------------------------------------------------------------
  var lastFocusedElement = null;

  function getDrawer() { return qs('[data-cart-drawer]'); }

  function string(name, fallback) {
    return (window.themeStrings && window.themeStrings[name]) || fallback;
  }

  // A marcacao aqui tem que ser a mesma de snippets/carrinho.liquid:
  // depois da primeira alteracao a lista inteira e reescrita por aqui.
  function itemRowHtml(item) {
    // Produto de variante unica mostra "Tamanho: <volume>" (volumes vindos
    // de window.themeVolumes, montado em snippets/carrinho.liquid); com
    // variantes, cada opcao como "Nome: valor".
    var variantHtml = '';
    if (item.product_has_only_default_variant) {
      var volume = window.themeVolumes && window.themeVolumes[item.handle];
      if (volume) {
        variantHtml = '<span class="cart-drawer__item-variant">Tamanho: ' + escapeHtml(volume) + '</span>';
      }
    } else {
      (item.options_with_values || []).forEach(function (option) {
        variantHtml += '<span class="cart-drawer__item-variant">' + escapeHtml(option.name) + ': ' + escapeHtml(option.value) + '</span>';
      });
    }

    // Preco do item sem o espaco depois do "R$" (ver o comentario no
    // Liquid): na fonte monoespacada ele abria um buraco.
    var itemMoney = function (cents) { return formatMoney(cents).replace(/\s|&nbsp;/g, ''); };
    var priceHtml;
    if (item.original_price !== item.final_price) {
      priceHtml =
        '<s>' + itemMoney(item.original_price) + '</s>' +
        '<span class="cart-drawer__item-price-sale">' + itemMoney(item.final_price) + '</span>';
    } else {
      priceHtml = itemMoney(item.final_price);
    }

    // Recorte sem fundo (URLs vindas de snippets/carrinho.liquid), como no
    // Liquid; sem recorte, a foto do produto.
    var recorte = window.themeRecortes && window.themeRecortes[item.handle];
    var imageHtml = '';
    if (recorte) {
      imageHtml =
        '<img src="' + recorte + '" alt="' + escapeHtml(item.product_title) + '" class="cart-drawer__item-image cart-drawer__item-image--recorte" loading="lazy" width="900" height="900">';
    } else if (item.image) {
      imageHtml =
        '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" class="cart-drawer__item-image" loading="lazy" width="80" height="107">';
    }

    return (
      '<li class="cart-drawer__item" data-cart-drawer-item data-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="cart-drawer__item-media" tabindex="-1" aria-hidden="true">' + imageHtml + '</a>' +
      '<div class="cart-drawer__item-content">' +
      '<a href="' + item.url + '" class="cart-drawer__item-name">' + escapeHtml(item.product_title) + '</a>' +
      variantHtml +
      '<div class="cart-drawer__item-price" data-cart-drawer-item-price>' + priceHtml + '</div>' +
      '</div>' +
      '<div class="cart-drawer__item-quantity">' +
      '<span class="cart-drawer__quantity-label" aria-hidden="true">' + escapeHtml(string('quantityLabel', 'Quantidade')) + '</span>' +
      '<div class="cart-drawer__quantity">' +
      '<button type="button" class="cart-drawer__quantity-button cart-drawer__quantity-button--minus" data-cart-drawer-decrease aria-label="' +
      escapeHtml(string('decreaseQuantity', 'Diminuir quantidade')) +
      '"' + (item.quantity <= 1 ? ' disabled' : '') + '>-</button>' +
      '<input type="number" class="cart-drawer__quantity-input" name="quantity" min="0" inputmode="numeric" value="' +
      item.quantity +
      '" data-cart-drawer-quantity aria-label="' +
      escapeHtml(string('quantityLabel', 'Quantidade')) +
      '">' +
      '<button type="button" class="cart-drawer__quantity-button cart-drawer__quantity-button--plus" data-cart-drawer-increase aria-label="' +
      escapeHtml(string('increaseQuantity', 'Aumentar quantidade')) +
      '">+</button>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove aria-label="' +
      escapeHtml(string('removeItem', 'Remover item')) +
      '">Remover</button>' +
      '</li>'
    );
  }

  // Contador "N itens" do cabecalho do drawer (continua visivel com a
  // sacola vazia, por isso nao usa [data-cart-count] do header).
  function updateDrawerCount(count) {
    var drawer = getDrawer();
    if (!drawer) return;
    var countEl = qs('[data-cart-drawer-count]', drawer);
    var textEl = qs('[data-cart-drawer-count-text]', drawer);
    if (countEl) countEl.textContent = count;
    if (textEl) {
      textEl.textContent = count === 1 ? string('cartItemSingular', 'item') : string('cartItemPlural', 'itens');
    }
  }

  // Aviso do frete gratis no kit. So existe com a promocao ligada nas
  // configuracoes do tema; os textos sao os de snippets/carrinho.liquid.
  function updateFreteGratis(count) {
    var box = qs('[data-cart-drawer-frete]');
    if (!box) return;
    var falta = (parseInt(box.dataset.meta, 10) || 3) - count;
    var textEl = qs('[data-cart-drawer-frete-text]', box);
    if (textEl) {
      textEl.textContent =
        falta > 1 ? 'Faltam ' + falta + ' perfumes para o frete grátis' :
        falta === 1 ? 'Falta 1 perfume para o frete grátis' :
        'Você ganhou frete grátis';
    }
    qsa('[data-cart-drawer-frete-passo]', box).forEach(function (el, i) {
      el.classList.toggle('is-cheio', i < count);
    });
  }

  function renderCartItems(cart) {
    var drawer = getDrawer();
    if (!drawer) return;

    var itemsList = qs('[data-cart-drawer-items]', drawer);
    var emptyState = qs('[data-cart-drawer-empty]', drawer);
    var content = qs('[data-cart-drawer-content]', drawer);
    var subtotalEl = qs('[data-cart-drawer-subtotal]', drawer);

    updateDrawerCount(cart.item_count);
    updateFreteGratis(cart.item_count);

    if (cart.item_count === 0) {
      if (itemsList) itemsList.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      if (content) content.hidden = true;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (content) content.hidden = false;
    if (itemsList) itemsList.innerHTML = cart.items.map(itemRowHtml).join('');
    // Sem o espaco depois do "R$", como no preco dos itens (fonte mono).
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price).replace(/\s|&nbsp;/g, '');
  }

  function openDrawer(triggerEl) {
    var drawer = getDrawer();
    if (!drawer) return;
    lastFocusedElement = triggerEl || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    var closeButton = qs('.cart-drawer__close', drawer);
    if (closeButton) closeButton.focus();
    document.addEventListener('keydown', handleDrawerKeydown);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.removeEventListener('keydown', handleDrawerKeydown);
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function isDrawerOpen() {
    var drawer = getDrawer();
    return !!drawer && drawer.classList.contains('is-open');
  }

  function handleDrawerKeydown(event) {
    if (!isDrawerOpen()) return;

    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }

    if (event.key === 'Tab') {
      var drawer = getDrawer();
      var panel = qs('.cart-drawer__panel', drawer);
      var focusable = qsa('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', panel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  // Arrastar o painel para a direita fecha o carrinho, como no drawer da
  // shop.dior.com.br (VTEX store-drawer, que usa um componente Swipable).
  // Se o dedo anda mais na vertical, e rolagem da lista: sai fora.
  function setupSwipeToClose() {
    var drawer = getDrawer();
    if (!drawer) return;
    var panel = qs('.cart-drawer__panel', drawer);
    if (!panel) return;

    var startX = 0;
    var startY = 0;
    var delta = 0;
    var tracking = false;
    var decided = false;

    panel.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      delta = 0;
      tracking = true;
      decided = false;
    }, { passive: true });

    panel.addEventListener('touchmove', function (event) {
      if (!tracking) return;
      var dx = event.touches[0].clientX - startX;
      var dy = event.touches[0].clientY - startY;

      if (!decided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        decided = true;
        if (Math.abs(dy) >= Math.abs(dx)) { tracking = false; return; }
        panel.classList.add('is-dragging');
      }

      delta = Math.max(0, dx);
      panel.style.transform = 'translate3d(' + delta + 'px, 0, 0)';
    }, { passive: true });

    function endSwipe() {
      if (!tracking) return;
      tracking = false;
      panel.classList.remove('is-dragging');
      panel.style.transform = '';
      // mesmo criterio do Swipable: passou de um quarto do painel, fecha
      if (delta > Math.min(120, panel.offsetWidth * 0.25)) closeDrawer();
      delta = 0;
    }

    panel.addEventListener('touchend', endSwipe);
    panel.addEventListener('touchcancel', endSwipe);
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartItems(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {
        if (typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta((window.themeStrings && window.themeStrings.cartError) || 'Ocorreu um erro ao atualizar seu carrinho.', 'negativo');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cart-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(openTrigger);
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var increaseButton = event.target.closest('[data-cart-drawer-increase]');
    if (increaseButton) {
      var item = increaseButton.closest('[data-cart-drawer-item]');
      var current = parseInt(qs('[data-cart-drawer-quantity]', item).value, 10) || 0;
      changeItem(item.dataset.key, current + 1);
      return;
    }

    var decreaseButton = event.target.closest('[data-cart-drawer-decrease]');
    if (decreaseButton) {
      var itemDec = decreaseButton.closest('[data-cart-drawer-item]');
      var currentDec = parseInt(qs('[data-cart-drawer-quantity]', itemDec).value, 10) || 0;
      changeItem(itemDec.dataset.key, Math.max(0, currentDec - 1));
      return;
    }

    var removeButton = event.target.closest('[data-cart-drawer-remove]');
    if (removeButton) {
      var itemRemove = removeButton.closest('[data-cart-drawer-item]');
      changeItem(itemRemove.dataset.key, 0);
    }
  });

  // Quantidade digitada direto no campo (o +/- ja passa por changeItem).
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-drawer-quantity]');
    if (!input) return;
    var row = input.closest('[data-cart-drawer-item]');
    if (!row) return;
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    changeItem(row.dataset.key, quantity);
  });

  // ------------------------------------------------------------
  // Add-to-cart (formularios de produto)
  // ------------------------------------------------------------
  function isAddToCartForm(form) {
    return form && form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]');
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!isAddToCartForm(form)) return;

    event.preventDefault();
    addToCart(form);
  }

  // O clique no botao e tratado aqui, antes de virar "submit". A Shopify
  // gera um product_added_to_cart quando um formulario de /cart/add e
  // enviado (mesmo cancelado) e outro quando o /cart/add.js responde:
  // com os dois, o Pixel da Meta recebia dois AddToCart com IDs
  // diferentes por clique, e a Meta contava o dobro. Cancelando o clique
  // o submit nem acontece, e so o fetch e contado. O listener de submit
  // fica para o Enter no teclado.
  function handleClick(event) {
    var button = event.target.closest('button, input[type="submit"]');
    if (!button || button.type !== 'submit' || !isAddToCartForm(button.form)) return;

    event.preventDefault();
    addToCart(button.form);
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"], [name="add"]');
    // Compra rapida (snippets/card-carousel.liquid): poe na sacola e vai
    // direto para o checkout, sem abrir a sacola. O segundo clique antes de
    // sair da pagina e ignorado, senao entrariam dois frascos.
    var compraRapida = form.hasAttribute('data-compra-rapida');
    var indoParaCheckout = false;
    if (compraRapida && button && button.getAttribute('aria-busy') === 'true') return;
    if (button) button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) {
            throw new Error((data && data.description) || 'add failed');
          });
        }
        return r.json();
      })
      .then(function () {
        if (compraRapida) {
          indoParaCheckout = true;
          window.location.href = '/checkout';
          return null;
        }
        return fetchCart();
      })
      .then(function (cart) {
        if (!cart) return;
        renderCartItems(cart);
        updateCartCount(cart.item_count);
        openDrawer(button);
      })
      .catch(function (error) {
        if (typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(error.message === 'add failed' ? ((window.themeStrings && window.themeStrings.cartError) || 'Ocorreu um erro ao atualizar seu carrinho.') : error.message, 'negativo');
        } else {
          form.submit();
        }
      })
      .finally(function () {
        if (button && !indoParaCheckout) button.removeAttribute('aria-busy');
      });
  }

  // Voltando do checkout pelo botao "voltar", o navegador restaura a pagina
  // do cache como ela estava: com o botao da compra rapida ainda ocupado.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    qsa('[data-compra-rapida] [aria-busy]').forEach(function (button) {
      button.removeAttribute('aria-busy');
    });
  });

  // ------------------------------------------------------------
  // Compra rapida no celular
  // ------------------------------------------------------------
  // Sem hover no celular: o botao sobe quando o dedo encosta no card (ao
  // arrastar o carrossel, por exemplo) e fica ate outro card ser tocado.
  // So vira clicavel depois de subir: um toque rapido no pe da foto cai no
  // link do produto, que esta embaixo, e nao no botao ainda invisivel.
  var cardCompraRapida = null;
  var timerCompraRapida = null;
  document.addEventListener('touchstart', function (event) {
    var card = event.target.closest('.carousel-card');
    if (!card || card === cardCompraRapida || !qs('[data-compra-rapida]', card)) return;
    if (cardCompraRapida) cardCompraRapida.classList.remove('is-compra-rapida', 'is-compra-rapida-clicavel');
    clearTimeout(timerCompraRapida);
    cardCompraRapida = card;
    card.classList.add('is-compra-rapida');
    timerCompraRapida = setTimeout(function () {
      card.classList.add('is-compra-rapida-clicavel');
    }, 350);
  }, { passive: true });

  document.addEventListener('click', handleClick);
  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', function () {
    setupSwipeToClose();
    fetchCart()
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateDrawerCount(cart.item_count);
        updateFreteGratis(cart.item_count);
      })
      .catch(function () {});
  });
})();
